import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $usersStore } from '@lib/store';
import { UserType } from '@shared/api/rest/users';
import { Managers } from './managers';
import { AddManagerModal } from './addManagersModal';
import { RemoveManagerModal } from './removeManagerModal';
import { Button, Spinner, Text } from '@shared/widgets';

interface ManagersBlockProps {
  accountId: number;
}

export const ManagersBlock = (props: ManagersBlockProps) => {
  const managersData = useUnit($usersStore.store);

  const [showAddMangerModal, setShowAddMangerModal] = useState<boolean>(false);
  const [showRemoveManagerModal, setShowRemoveManagerModal] = useState<boolean>(false);

  const { t } = useTranslation('account');

  useEffect(() => {
    //TODO connect  assignedAccountId: props.accountId when api ready
    $usersStore.events.update({
      userType: UserType.MANAGER,
      // assignedAccountId: props.accountId,
    });
  }, []);

  const closeAddModal = (confirm?: boolean) => {
    setShowAddMangerModal(false);
    if (confirm) $usersStore.events.update({ userType: UserType.MANAGER });
  };
  const closeRemoveModal = (confirm?: boolean) => {
    setShowRemoveManagerModal(false);
    if (confirm) $usersStore.events.update({ userType: UserType.MANAGER });
  };

  return (
    <div className='flex flex-col gap-6'>
      <div className='flex w-full justify-between overflow-x-auto'>
        <Text weight='semibold' size='2xl'>
          {t('managers.title')}
        </Text>
        <div className='flex gap-2'>
          <Button color='outlined' onClick={() => setShowAddMangerModal(true)}>
            {t('buttons.add', { ns: 'common' })}
          </Button>
          <Button color='outlined' onClick={() => setShowRemoveManagerModal(true)}>
            {t('buttons.remove', { ns: 'common' })}
          </Button>
        </div>
      </div>
      {managersData.loading ? <Spinner /> : <Managers data={managersData.data.filter((m) => m.accounts.includes(props.accountId))} />}
      <AddManagerModal
        isOpen={showAddMangerModal}
        onClose={closeAddModal}
        accountId={props.accountId}
        data={managersData.data.filter((m) => !m.accounts.includes(props.accountId))}
      />
      <RemoveManagerModal
        isOpen={showRemoveManagerModal}
        onClose={closeRemoveModal}
        accountId={props.accountId}
        data={managersData.data.filter((m) => m.accounts.includes(props.accountId))}
      />
    </div>
  );
};
